import { createSlice } from "@reduxjs/toolkit";
import { shiftLocalDate } from "utils/hideWeekendsSetting";

// Utility constants
const daysLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const getOrdinalSuffix = (n) => {
  if (n >= 11 && n <= 13) return 'th';
  const lastDigit = n % 10;
  if (lastDigit === 1) return 'st';
  if (lastDigit === 2) return 'nd';
  if (lastDigit === 3) return 'rd';
  return 'th';
};


const formatDate = (dateObject) => {
  const day = dateObject.getDate();
  return {
    dayName: daysLong[dateObject.getDay()],
    dayNamePlural: `${daysLong[dateObject.getDay()]}s`,
    dateString: `${monthsLong[dateObject.getMonth()]} ${day}${getOrdinalSuffix(day)}, ${dateObject.getFullYear()}`,
    year: dateObject.getFullYear(),
    month: dateObject.getMonth(),
    day,
    databaseFormattedDate: dateObject.toLocaleDateString('en-CA')
  };
};

const initialDate = formatDate(new Date());

const dateSlice = createSlice({
  name: "date",
  initialState: {
    current: initialDate,
  },
  reducers: {
    incrementDate: (state, action) => {
      const skipWeekends = Boolean(action.payload?.skipWeekends);
      const current = new Date(state.current.year, state.current.month, state.current.day);
      state.current = formatDate(shiftLocalDate(current, 1, { skipWeekends }));
    },
    decrementDate: (state, action) => {
      const skipWeekends = Boolean(action.payload?.skipWeekends);
      const current = new Date(state.current.year, state.current.month, state.current.day);
      state.current = formatDate(shiftLocalDate(current, -1, { skipWeekends }));
    },
    setDate: (state, action) => {
      const custom = new Date(action.payload.year, action.payload.month, action.payload.day);
      state.current = formatDate(custom);
    },
    setDateFromMoment: (state, action) => {
      const e = action.payload;
      const custom = new Date(e._d.getFullYear(), e._d.getMonth(), e._d.getDate());
      state.current = formatDate(custom);
    },
    resetDateToToday: (state) => {
      state.current = formatDate(new Date());
    },
  }
});

export const { incrementDate, decrementDate, setDate, setDateFromMoment, resetDateToToday } = dateSlice.actions;
export const selectDate = (state) => state.date.current;
export default dateSlice.reducer;
